import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsBadgeModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsSingleDecimalPointModule } from '../../common/pipe/single-decimal-point';
import { CmpsVirtualScrollModule } from '../../common/virtual-scroll';
import { CmpsLazyRouterModule } from '../../route.module';
import { CmpsReportBuilderSelectionModule } from '../builder-selection';

import { RunComponent } from './component/run/run.component';
import { RunsComponent } from './component/runs/runs.component';

@NgModule({
    declarations: [RunComponent, RunsComponent],
    imports: [
        CmpsBadgeModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyRouterModule,
        CmpsReportBuilderSelectionModule,
        CmpsSingleDecimalPointModule,
        CmpsTooltipModule,
        CmpsVirtualScrollModule,
        CommonModule,
    ],
})
export class CmpsReportRunModule {}
